import $ from "jquery";
export default {
	finalize() {

		window.almEmpty = function(alm){
			var el = alm.listing;
			var msg = 'Sorry, nothing found in this Ajax Load More query';
			
			var item = document.createElement('span');
			item.innerHTML = msg;
			el.appendChild(item); // Append to ALM
			
			console.log("Nothing found in this Ajax Load More query :(");
		};
		
	}
}